import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import WhatsAppButton from "../component/WhatsAppButton";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import { withTranslation } from 'react-i18next';

class Canteras extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.getServiceImage = this.getServiceImage.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  getServiceImage(lang) {
    try {
      return require(`../assets/images/service/${lang}/service-01.jpg`);
    } catch (e) {
      return require(`../assets/images/service/es/service-01.jpg`);
    }
  }

  render() {
    const { t, i18n } = this.props;
    const lang = i18n.language || 'es';
    const serviceImg = this.getServiceImage(lang);

    return (
      <React.Fragment>
        {/* Start Pagehelmet */}
        <PageHelmet pageTitle={t('Las canteras')} />
        {/* End Pagehelmet */}

        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        {/* Start Breadcrump Area */}
        <Breadcrumb title={t('Las canteras')} />
        {/* End Breadcrump Area */}

        {/* Start Page Wrapper */}
        <div className="rn-service-details ptb--80 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="service-details-inner">
                  <div className="inner">
                    {/* Start Single Area */}
                    <div className="row sercice-details-content align-items-center">
                      <img
                        className="w-100" style={{ borderRadius: '10px' }}
                        src={serviceImg}
                        alt="quarries location"
                      />
                    </div>
                    {/* End Single Area */}

                    {/* Start Single Area */}
                    <div className="sercice-details-content align-items-center">
                      <div className="details mt_md--30 mt_sm--30">
                        <h4 className="title">{t("canteras-titulo-1")}</h4>
                        <p dangerouslySetInnerHTML={{ __html: t('canteras-parrafo-1') }} />
                      </div>
                    </div>
                    {/* End Single Area */}

                    {/* Start Single Area */}
                    <div className="sercice-details-content align-items-center">
                      <div className="details mt_md--30 mt_sm--30">
                        <h4 className="title">{t("canteras-titulo-2")}</h4>
                        <p dangerouslySetInnerHTML={{ __html: t('canteras-parrafo-2') }} />
                      </div>
                    </div>
                    {/* End Single Area */}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Page Wrapper */}

        {/* Start Whatsapp Button */}
        <div>
          <WhatsAppButton />
        </div>
        {/* End Whatsapp Button */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}

        <Footer />
      </React.Fragment>
    );
  }
}

export default withTranslation()(Canteras);
